export default __webpack_public_path__ + "static/Andrew.JohnsonBoardOfDirectorsGeneralCounsel_social-16646becce3e0182570b4af48b7dc655.jpg";